<template>
  <apollo-mutation :mutation='updatePostMutation'>

    <template v-slot="{mutate,error,loading}">

      <apollo-mutation :mutation='adminVoteMutation'>

        <template v-slot="{mutate:mutate2,loading:loading2}">
          <pbc-popup @close='$emit("close")'>
            <div v-if='loading || loading2'>adminning</div>
            <div v-if='error'>error {{error}}</div>
            <div class="m-3 rounded shadow flex flex-col justify-center">
              <h3 class="p-1 text-2xl text-gray-800 font-semibold">Admin</h3>
              <div class="p-2 py-4 flex justify-center">
                <pbc-button @click='onPin(mutate)'>
                  Pin
                </pbc-button>
                <pbc-button @click='onUnpin(mutate)'>
                  Unpin
                </pbc-button>
                <pbc-button @click='onHide(mutate)'>
                  Hide
                </pbc-button>
                <pbc-button @click='onAdminVote(mutate2, "upvote")'>
                  Admin Upvote
                </pbc-button>
                <pbc-button @click='onAdminVote(mutate2, "downvote")'>
                  Admin Downvote
                </pbc-button>
              </div>
            </div>
          </pbc-popup>


        </template>
      </apollo-mutation>

    </template>
</apollo-mutation>

</template>
<script>
import { updatePostMutation } from '@/gql/Queries.js';
import PbcPopup from '@ui/molecules/PbcPopup.vue';
import gql from 'graphql-tag';
const adminVoteMutation = gql(`
  mutation adminVotePost($id: String!, $type: String!) {
    adminVotePost(id: $id, type: $type) {
      id
      upvotes
      downvotes
    }
  }
`);

export default {
  props:{
    id:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      updatePostMutation,
      adminVoteMutation
    }
  },
  methods:{
    async onUnpin(mutate) {
      const id = this.id;
      const pinned = 0;
      const voted = await mutate({variables: {
        id,
        pinned
      }})
    },
    async onPin(mutate) {
      const id = this.id;
      const pinned = new Date().getTime();
      const voted = await mutate({variables: {
        id,
        pinned
      }})
    },
    async onAdminVote(mutate, type) {
      const id = this.id;
      console.log('le id', id);
      const voted = await mutate({variables: {
        id,
        type
      }})
    },
    async onHide() {
    }
  },
  components:{
    PbcPopup
  }
}
</script>
